import { defaultFont } from "./material-kit-react.js";

import tooltip from "./tooltipsStyle.js";

const headerLinksStyle = (theme) => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit",
  },
  listItem: {
    float: "left",
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: "#e5e5e5",
      },
    },
  },
  listItemText: {
    padding: "0 !important",
  },
  navLink: {
    color: "#172033",
    position: "relative",
    padding: "9px 12px",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "none",
    borderRadius: "10px",
    lineHeight: "18px",
    textDecoration: "none",
    margin: "0 2px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    boxShadow: "none",
    transition: "all 0.2s ease",
    "&:hover,&:focus": {
      color: "#244FC8",
      backgroundColor: "#EEF3FF",
      fontSize: "12px",
      boxShadow: "none",
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start",
      },
    },
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px",
  },
  registerNavLink: {
    top: "3px",
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  icons: {
    width: "16px",
    height: "16px",
    marginRight: "5px",
    color: "currentColor",
  },
  socialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px",
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px",
    },
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px",
  },
  option: {
    "&:hover,&:focus": {
      background: "rgba(200, 200, 200, 0.2)",
    },
    display: "flex",
    height: "30px",
    cursor: "pointer",
    padding: "0 10px",
    borderRadius: "6px",
    alignItems: "center",
    width: "60px",
    fontSize: "12px",
  },
  optionUl: {
    zIndex: 3000,
    position: "absolute",
    padding: "8px",
    marginTop: "8px",
    borderRadius: "6px",
    background: "#fff",
    boxShadow: "0 0 3px rgba(0,0,0,0.1)",
  },
  toggleDropdown: {
    display: "flex",
    height: "25px",
    background: "#fff",
    padding: "5px 10px",
    fontSize: "12px",
    fontWeight: "500",
    borderRadius: "6px",
    alignItems: "center",
    cursor: "pointer",
    justifyContent: "space-between",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    border: "1px solid #E0E0E0",
    minWidth: "90px",
  },
});

export default headerLinksStyle;
